export default (inletElement: HTMLElement) => {
  const appSpinnerElement = inletElement.getElementsByClassName('external-widget-loader-loading')[0] as HTMLElement
  let showWithDelay = false
  let timeoutId = (null as unknown) as number

  return {
    show: (inMillis = 1000) => {
      showWithDelay = true
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      timeoutId = window.setTimeout(() => {
        if (appSpinnerElement && showWithDelay) {
          showWithDelay = false
          appSpinnerElement.style.display = 'block'
        }
      }, inMillis)
    },

    showImmediate: () => {
      if (appSpinnerElement) {
        appSpinnerElement.style.display = 'block'
      }
    },

    hide: () => {
      if (appSpinnerElement) {
        showWithDelay = false
        if (timeoutId) {
          clearTimeout(timeoutId)
        }
        appSpinnerElement.style.display = 'none'
      }
    }
  } as IAppSpinner
}

export interface IAppSpinner {
  show(inMillis?: number): void
  showImmediate(): void
  hide(): void
}
